import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { useHistory } from 'react-router-dom'

import { useTrack } from 'hooks/analytics_events'

import { sampleRecapButtonTracking } from '../../tracking'

export const SampleRecapButton = ({ ctaKey = 'recaps_page' }) => {
  const track = useTrack()
  const history = useHistory()

  const handleClick = () => {
    const trackingEvent = ctaKey === 'ai_notetaker_settings' ? sampleRecapButtonTracking.settingsPage : sampleRecapButtonTracking.recapsPage

    try {
      track({
        name: trackingEvent.name,
        properties: trackingEvent.props
      })
    } catch (error) {
      console.warn('Analytics tracking failed:', error)
    }

    history.push('/app/tracked_meetings/sample')
  }

  return (
    <Button decoration="secondary-outline" onClick={handleClick}>
      {I18n.t('publisher.ai_onboarding_wizard.step_one.modal.recap_btn')}
    </Button>
  )
}
